// all product add to cart 


// popup open and close
document.querySelectorAll('.block__new-lookbook__list-container .block__new-lookbook-item').forEach(ele => {
  ele.addEventListener('click', () => {

    // Close all open popups and overlays
    document.querySelectorAll('.block__new-lookbook__popuop.active, .block__new-lookbook__popuop_overlaye.active').forEach(el => {
      el.classList.remove('active');
    });

    // Open the current popup and overlay
    const popup = ele.querySelector('.block__new-lookbook__popuop');
    const overlay = ele.querySelector('.block__new-lookbook__popuop_overlaye');

    if (popup) popup.classList.add('active');
    if (overlay) overlay.classList.add('active');

    // popup__close button
    if (popup) {
      const closeBtn = popup.querySelector('.popup__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          popup.classList.remove('active');
          if (overlay) overlay.classList.remove('active');
        });
      }
    }
  });
});



   async function setupCartAllButtonClick () {

        let popup = document.querySelector('.block__new-lookbook__popuop.active');

        if (popup) {
          let addToCartButtons = popup.querySelectorAll('.m-add-to-cart');

          for (let i = 0; i < addToCartButtons.length; i++) {
            addToCartButtons[i].click();
            await new Promise(resolve => setTimeout(resolve, 1000)); // 1 second delay
          }
        }

    }
